<template>
  <base-layout pageTitle="Basket">
  <div v-if="productsLoaded">

    <div class="text-center flex h-screen" v-if="!getProductById.length">
    <div class="m-auto">
      <p class="text-7xl">0</p>
      <p class="text-xl my-2">No items in your basket yet...</p>
      <button class="mb-2 w-full rounded-lg bg-indigo-200 text-indigo-800 hover:text-white px-4 py-3 font-semibold text-lg leading-tight hover:bg-indigo-700 " @click="continueShopping">start shopping</button>
    </div>
  </div>
    <div v-else class="m-4">
      <div class="my-3" v-for="item in getProductById" :key="item.id">
        <BasketItem :image="item.main_image.small_square_crop" :title="item.title" :id="item.id" :quantity="item.quantity" :price="item.price" />
      </div>
           
        <div class="flex items-center bg-gray-100 shadow-inner rounded-lg px-2 py-2 my-2 ">
            <p class=" text-xl font-black text-gray-700">Total: ${{getBasketTotalPrice}}</p>
        </div>
      <div class="mb-20">
      <button class="mb-2 w-full rounded-lg bg-indigo-600 text-indigo-50 px-4 py-3 font-semibold text-lg leading-tight shadow-md hover:bg-indigo-700  " @click="continueShopping">Continue shopping</button>
      <button class="w-full rounded-lg bg-green-600 text-green-50 px-4 py-3 font-semibold text-lg leading-tight shadow-md hover:bg-green-100 hover:text-green-600 " @click="moveToCheckout">Checkout</button>
      </div>
    </div>

  </div>
  <div v-else>
    <div class="text-center flex h-screen">
    <div class="m-auto">
      <p class="text-xl font-semibold ">Loading your Basket...</p>
    </div>
    </div>
  </div>
   
  </base-layout>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { useRouter } from 'vue-router'
import BasketItem from '../../components/BasketItem.vue'
export default {
  components: {BasketItem},
  setup(){
    const router = useRouter()
    return { router }
  },
  computed: {    
    ...mapGetters('basket',{
      getProductById:'cartProducts',
      getBasketTotalPrice:'basketTotalPrice'
    }),
    productsLoaded(){
      // Returns true if all products are loaded
      return this.$store.state.inventory.productsLoaded
    }
  },
  methods: {
    continueShopping(){
      this.router.replace({ name:'meals' })
    },
    moveToCheckout(){
      this.router.replace({ name:'checkoutPage' })
    },
    ...mapActions('basket', {
      checkout:'checkout'
    })
  }

}
</script>

<style scoped>

</style>